import { render, staticRenderFns } from "./updatePass.vue?vue&type=template&id=bf7a05ee&scoped=true"
import script from "./updatePass.vue?vue&type=script&lang=js"
export * from "./updatePass.vue?vue&type=script&lang=js"
import style0 from "./updatePass.vue?vue&type=style&index=0&id=bf7a05ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf7a05ee",
  null
  
)

export default component.exports